import { AdhesionUnitWatcher } from '@mbrtargeting/metatag-shared-modules';
import { AdhesionUnitWatcherInterface } from '@mbrtargeting/metatag-shared-types';
import { getBrowserDetails, isNonEmptyString } from '@mbrtargeting/metatag-utils';
import { inject, injectionTarget } from '../../../loader/decorators/inject.js';
import { ConfigResolver } from '../../../loader/essentials/config-resolver.js';
import { selectFeatureSettings } from '../../../loader/essentials/config-selector.js';
import { CONFIG_RESOLVER } from '../../../loader/token.js';

@injectionTarget()
export class MetaTagAdhesionUnitWatcher extends AdhesionUnitWatcher implements AdhesionUnitWatcherInterface {

    @inject(CONFIG_RESOLVER) configResolver!: ConfigResolver;

    constructor() {
        super();
        const { adhesionUnitQuery = '', mobileAdhesionUnit = [], desktopAdhesionUnit = [], adhesionUnitGap = '0' } = this.configResolver.get(selectFeatureSettings());
        const { isPhone } = getBrowserDetails();

        //migration path for new array-based query lists. Remove after websiteConfigurations are migrated.
        let adhesionUnitQueries;
        if (mobileAdhesionUnit.length === 0 && desktopAdhesionUnit.length === 0 && isNonEmptyString(adhesionUnitQuery)) {
            adhesionUnitQueries = [adhesionUnitQuery];
        } else {
            adhesionUnitQueries = isPhone ? mobileAdhesionUnit : desktopAdhesionUnit;
        }

        this.init({
            adhesionUnitQueries,
            adhesionUnitGap: parseInt(adhesionUnitGap)
        });
    }
}
